var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 16.2v-6.1h2l.2-2.4h-2.2V6.1c0-.6.2-1.1 1.2-1.1h1.2V2.9c-.2 0-1-.1-1.9-.1-1.9 0-3.1 1.1-3.1 3.1v1.8h-2V10h2.1v6.2h2.5z"
  })));
};
export default SvgSocialFacebook;